import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/accounting-periods`;

export const accountingPeriodService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.fiscal_year) params.append('fiscal_year', filters.fiscal_year);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  close: async (id, body = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/close`, body);
    return response.data;
  },

  reopen: async (id, body = {}) => {
    const response = await axios.post(`${API_BASE}/${id}/reopen`, body);
    return response.data;
  }
};

export default accountingPeriodService;
